const tabs = [
  {
    id: 'list',
    name: '商品一覧'
  },
  {
    id: 'add-by-amazon',
    name: 'Amazonから追加'
  },
  {
    id: 'reports',
    name: 'レポート'
  }
]
export default tabs



// WEBPACK FOOTER //
// ./src/common/products-tabs.js